import React from 'react';
import './App.css';

function App() {
  const siteName = 'Killer Site Builder';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
